import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';

import { useGetProfileQuery } from '@/api/profilesApi';
import AvatarWithMenu from '@/components/Shared/AvatarWithMenu';
import { BirthdayIcon } from '@/scenes/Dybr/Users/BirthdayIcon';
import { useTokenState } from '@/store/localStorage/useTokenState';
import SimpleArrowLeftWithBackground from '@/styles/Icons/SimpleArrowLeftWithBackground';

import css from './ConversationHeader.module.css';

export function ConversationHeader({ size = 'md' }: { size?: 'sm' | 'md' | 'lg' }) {
  const { targetProfileId } = useParams<{ targetProfileId: string }>();
  const [token] = useTokenState();
  const isLoggedIn = Boolean(token);
  const headerRef = useRef<HTMLDivElement>(null);
  const [isSticky, setIsSticky] = useState(false);

  const { data: targetProfile } = useGetProfileQuery(
    { profileId: targetProfileId || '' },
    { skip: !targetProfileId || !isLoggedIn }
  );

  useEffect(() => {
    const currentHeader = headerRef.current;

    if (!currentHeader) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsSticky(!entry.isIntersecting);
      },
      {
        threshold: 0,
        rootMargin: '-1px 0px 0px 0px'
      }
    );

    observer.observe(currentHeader);

    return () => {
      observer.unobserve(currentHeader);
    };
  }, []);

  if (!isLoggedIn || !targetProfile) {
    return (
      <div className={css.header} aria-hidden="true">
        <div className={css.headerSideContainer} />
        <div className={css.profileHeader}>
          <div className={css.skeletonAvatar} />
          <div className={css.skeletonNickname} />
        </div>
        <div className={css.headerSideContainer} />
      </div>
    );
  }

  return (
    <>
      {/* Sticky compacted header */}
      <div className={`${css.stickyHeader} ${css.stickyHeaderVisible} ${size ? css[size] : ''}`}>
        <div className={css.stickyContent}>
          <Link to="/direct" className={css.backButton}>
            <span className="icon">
              <SimpleArrowLeftWithBackground className={css.backButtonIcon} />
            </span>
            <div className={css.backButtonText}>вернуться ко всем разговорам</div>
          </Link>
          <div className={css.stickyProfileInfo}>
            <AvatarWithMenu className="profile-avatar direct-message-header compact" profile={targetProfile} />
            <span className={css.stickyNickname}>{targetProfile.nickname}</span>
          </div>
          <div className={css.spacer} />
        </div>
      </div>

      {/* Original header */}
      {false && (
        <div ref={headerRef} className={css.header}>
          <div className={css.headerSideContainer}>
            {/* Replaced ArrowIconWithBackground styled-component with Link and CSS modules */}
            <Link to="/direct" className={css.backButton}>
              <span className="icon">
                <SimpleArrowLeftWithBackground className={css.backButtonIcon} />
              </span>
              <div className={css.backButtonText}>вернуться ко всем разговорам</div>
            </Link>
          </div>
          {/* Replaced DirectMessageHeaderProfile styled-component with div and CSS modules */}
          <div className={css.profileHeader}>
            <AvatarWithMenu className="profile-avatar direct-message-header" profile={targetProfile} />
            <BirthdayIcon birthday={targetProfile.birthday || ''} nick={targetProfile.nickname} />
            <div className={css.nickname}>{targetProfile.nickname}</div>
          </div>
          <div className={css.headerSideContainer} />
        </div>
      )}
    </>
  );
}
